var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"component__icon",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.icon].toSvg({
    height: _vm.getHeight,
    width: _vm.getWidth,
    color: _vm.getColor
  }))}})}
var staticRenderFns = []

export { render, staticRenderFns }